import { createSelector, createFeatureSelector, ActionReducerMap } from '@ngrx/store';
import * as fromCop from '../cop/cop.reducer';
import { copModuleKey, CopModuleState } from '../cop/cop.reducer';
import { SectionWidgetUserSettings } from '../lsd/models/map-configuration.model';

const selectCopModuleState = createFeatureSelector<CopModuleState>(copModuleKey);

const selectCopState = createSelector(selectCopModuleState, (state: CopModuleState) => state?.cop);

export const selectSelectedFolder = createSelector(selectCopState, fromCop.getSelectedFolder);
export const selectShowLayerOptionsTab = createSelector(selectCopState, fromCop.getShowLayerOptionsTab);
export const selectSelectedFolderForDelete = createSelector(selectCopState, fromCop.getSelectedFolderForDelete);
export const selectIsMapNew = createSelector(selectCopState, fromCop.getIsMapNew);
export const selectIsFolderEdit = createSelector(selectCopState, fromCop.getIsFolderEdit);
export const selectIsTrySaveMap = createSelector(selectCopState, fromCop.getIsTrySaveMap);
export const selectIsFolderWorkflowSummaryConfigEdit = createSelector(selectCopState, fromCop.getIsFolderWorkflowSummaryConfigEdit);
export const selectSelectedLayer = createSelector(selectCopState, fromCop.getSelectedLayer);
export const selectSelectedLayerForDelete = createSelector(selectCopState, fromCop.getSelectedLayerForDelete);
export const selectIsLayerEdit = createSelector(selectCopState, fromCop.getIsLayerEdit);
export const selectIsLayerNew = createSelector(selectCopState, fromCop.getIsLayerNew);
export const selectDatasetsForSelect = createSelector(selectCopState, fromCop.getDatasetsForSelect);
export const selectFolderExpanded = createSelector(selectCopState, fromCop.getFolderExpanded);
export const selectLayerVisibility = createSelector(selectCopState, fromCop.getLayerVisibility);
export const selectGeoFieldsForOptionalDisplay = createSelector(selectCopState, fromCop.getGeoFieldsForOptionalDisplay);
export const selectWorkflowStatusVisibilityByLayerTypeAndName = createSelector(
  selectCopState,
  fromCop.getWorkflowStatusVisibilityByLayerTypeAndName
);
export const selectWorkflowStatusExpandedByLayerTypeAndName = createSelector(
  selectCopState,
  fromCop.getWorkflowStatusExpandedByLayerTypeAndName
);
export const selectSectionWidgetUserSettings = createSelector(selectCopState, fromCop.getSectionWidgetUserSettings);
export const selectSectionWidgetUserSettingsForFolder = (folderUId: string) =>
  createSelector(selectCopState, (state): SectionWidgetUserSettings => {
    return state?.mapSettings?.sectionWidgetUserSettings[folderUId] || {};
  });
export const selectHiddenDocumentsByLayer = createSelector(selectCopState, fromCop.getHiddenDocumentsByLayer);

export const selectFolderVisibility = createSelector(selectCopState, fromCop.getFolderVisibility);
export const selectLayerOpacity = createSelector(selectCopState, fromCop.getLayerOpacity);
export const selectIsLeftDrawerOpen = createSelector(selectCopState, fromCop.getIsLeftDrawerOpen);
export const selectWorkflowStatusSummary = createSelector(selectCopState, fromCop.getWorkflowStatusSummary);

// settings
export const selectLayerQuickFilterSelections = createSelector(selectCopState, fromCop.getLayerQuickFilterSelections);
export const selectTropicalCycloneProperties = createSelector(selectCopState, fromCop.getTropicalCycloneProperties);
